module.exports = __webpack_public_path__ + "static/employee-notifications-9931fa1a59847896f7cb11ada0f54d1e.png";